function initTabs() {
    document.querySelectorAll('.tabs').forEach(tabs => {
        const pageId = tabs.dataset.pageId;
        const tabButtons = Array.from(tabs.querySelectorAll('[role="tab"]'));
        const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));

        if (!tabButtons.length) {
            return;
        }

        function activate(tab, { focus = false } = {}) {
            tabButtons.forEach(button => {
                const isSelected = button === tab;
                button.setAttribute('aria-selected', String(isSelected));
                button.tabIndex = isSelected ? 0 : -1;
            });

            panels.forEach(panel => {
                panel.hidden = panel.id !== tab.getAttribute('aria-controls');
            });

            if (focus) {
                tab.focus();
            }
        }

        tabButtons.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                if (tab.getAttribute('aria-selected') === 'true') {
                    return;
                }

                activate(tab);
                saveTab(pageId, tab.dataset.tab);
            });

            tab.addEventListener('keydown', e => {
                let target;

                switch (e.key) {
                    case 'ArrowRight':
                        target = tabButtons[(index + 1) % tabButtons.length];
                        break;
                    case 'ArrowLeft':
                        target = tabButtons[(index - 1 + tabButtons.length) % tabButtons.length];
                        break;
                    case 'Home':
                        target = tabButtons[0];
                        break;
                    case 'End':
                        target = tabButtons[tabButtons.length - 1];
                        break;
                    default:
                        return;
                }

                e.preventDefault();
                activate(target, { focus: true });
                saveTab(pageId, target.dataset.tab);
            });
        });
    });
}

// Existing behaviour: the selected tab is remembered in the session so it survives reloads and login.
async function saveTab(pageId, tab) {
    try {
        const response = await fetch("/api/handbook/savetab/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ pageId, tab })
        });

        if (!response.ok) {
            console.log(await response.text());
        }
    }
    catch (error) {
        console.log(error);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
} else {
    initTabs();
}